import { Action } from 'redux-actions'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import api from '../../../services/api.services'
import {
  CreateAnnouncement$Request,
  DeleteAnnouncements$Request,
  EditAnnouncement$Request,
  GetAnnouncementFilters$Request,
  GetAnnouncements$Request,
} from '../../../services/api.types'
import {
  createAnnouncement,
  createAnnouncementFail,
  createAnnouncementSuccess,
  deleteAnnouncements,
  deleteAnnouncementsFail,
  deleteAnnouncementsSuccess,
  editAnnouncement,
  editAnnouncementFail,
  editAnnouncementSuccess,
  getAnnouncementFilters,
  getAnnouncementFiltersFail,
  getAnnouncementFiltersSuccess,
  getAnnouncements,
  getAnnouncementsFail,
  getAnnouncementsSuccess,
} from './AnnouncementsActions'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { t } from 'ttag'
import { scrollToTop } from '../../../common/helpers/scroll'
import { push } from 'connected-react-router'

function* sagaGetAnnouncements(action: Action<GetAnnouncements$Request>) {
  try {
    const { announcements } = yield call(api.users.getAnnouncements, action.payload)
    yield put({ type: String(getAnnouncementsSuccess), payload: announcements })
  } catch (e: any) {
    console.log('GetAnnouncementsFailed: ', e)
    yield put({ type: String(getAnnouncementsFail) })
  }
}

function* sagaGetAnnouncementFilters(action: Action<GetAnnouncementFilters$Request>) {
  try {
    // @ts-ignore
    const payload = yield call(api.users.getAnnouncementFilters, action.payload)
    yield put({ type: String(getAnnouncementFiltersSuccess), payload })
    yield put({ type: String(clearNotification) })

    if (payload.announcementLimitExceeded) {
      const notification: INotification = {
        type: 'warning',
        content: t`Announcement limit has been exceeded for this date. Please try to use filters or schedule it for a later date!`,
      }
      yield put({ type: String(addNotification), payload: notification })
    }
  } catch (e: any) {
    console.log('getAnnouncementFiltersFail: ', e)
    yield put({ type: String(getAnnouncementFiltersFail) })
  }
}

function* sagaCreateAnnouncement(action: Action<CreateAnnouncement$Request>) {
  try {
    yield put({ type: String(clearNotification) })
    const { notificationId } = yield call(api.users.createAnnouncement, action.payload)
    yield put({ type: String(createAnnouncementSuccess), payload: notificationId })
    yield put(push('/admin/announcements'))
  } catch (e: any) {
    console.log('CreateAnnouncementFail: ', e)
    yield put({ type: String(createAnnouncementFail) })

    // const msg = e.message
    const content = t`Announcement creation failed. Please try again!`
    /*if (msg === 'Another team already created') {
      content = t`You have already created another team. You can only create one team.`
    } else if (msg === 'Team with the same name already exists') {
      content = t`A team with the same name already exists. Please choose a different name.`
    } else if (msg === 'Team selection is locked') {
      content = t`Your admin has disabled team selection.`
    }*/

    const errorNotification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: errorNotification })
    scrollToTop()
  }
}

function* sagaEditAnnouncement(action: Action<EditAnnouncement$Request>) {
  try {
    yield put({ type: String(clearNotification) })
    const { notificationId } = yield call(api.users.editAnnouncement, action.payload)
    yield put({ type: String(editAnnouncementSuccess), payload: notificationId })
    yield put(push('/admin/announcements'))
  } catch (e: any) {
    console.log('EditAnnouncementFail: ', e)
    yield put({ type: String(editAnnouncementFail) })

    // const msg = e.message
    const content = t`Announcement edit failed. Please try again!`
    /*if (msg === 'Another team already created') {
      content = t`You have already created another team. You can only create one team.`
    } else if (msg === 'Team with the same name already exists') {
      content = t`A team with the same name already exists. Please choose a different name.`
    } else if (msg === 'Team selection is locked') {
      content = t`Your admin has disabled team selection.`
    }*/

    const errorNotification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: errorNotification })
    scrollToTop()
  }
}

function* sagaDeleteAnnouncements(action: Action<DeleteAnnouncements$Request>) {
  try {
    yield call(api.users.deleteAnnouncements, action.payload)
    yield put({ type: String(deleteAnnouncementsSuccess) })
  } catch (e: any) {
    console.log('DeleteAnnouncementsFail: ', e)
    yield put({ type: String(deleteAnnouncementsFail) })
  }
}

export function* announcementsSagas() {
  yield all([
    takeEvery(String(getAnnouncements), sagaGetAnnouncements),
    takeEvery(String(getAnnouncementFilters), sagaGetAnnouncementFilters),
    takeEvery(String(createAnnouncement), sagaCreateAnnouncement),
    takeEvery(String(editAnnouncement), sagaEditAnnouncement),
    takeEvery(String(deleteAnnouncements), sagaDeleteAnnouncements),
  ])
}
